import { ButtonV1 } from '@northladder/design-system';

import { translations } from '../../../translations';

interface IDoneUploadingImagesCTAProps {
  isEnabled: boolean;
  onClickDone: () => void;
}

export function DoneUploadingImagesCTA({
  isEnabled,
  onClickDone,
}: IDoneUploadingImagesCTAProps) {
  const handleOnClick = () => {
    onClickDone();
  };

  return (
    <div>
      <ButtonV1
        className="mt-2 w-auto px-12"
        isEnabled={isEnabled}
        isLoading={false}
        label={translations.done}
        loadingLabel={translations.pleaseWait}
        onClick={handleOnClick}
        type="button"
      />
    </div>
  );
}
